import { render, staticRenderFns } from "./DetailedSlotReserved.vue?vue&type=template&id=022a3a16&"
import script from "./DetailedSlotReserved.vue?vue&type=script&lang=ts&"
export * from "./DetailedSlotReserved.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedSlotReserved.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports